module.exports = __webpack_public_path__ + "static/lohmanders-3726214304343b5b860e9f1b6cef67e0.png";